import { DesktopDisplayContainer, MobileDisplayContainer } from '@components/DeviceContainer'
import React from 'react'
import styled from 'styled-components'
import sexConfigJSON from '../../../../public/config/sex.json'

const StyledImage = styled.img`
  display: block;
  width: 100%;
  cursor: pointer;
`

interface ISexBannerProps {
  handleBannerOnClick: () => void
  url: string
}

const SexBanner = ({ url, handleBannerOnClick }: ISexBannerProps) => {
  return (
    <a href={url} onClick={handleBannerOnClick}>
      <DesktopDisplayContainer>
        <StyledImage src={sexConfigJSON['banner']['pc']} />
      </DesktopDisplayContainer>
      <MobileDisplayContainer>
        <StyledImage src={sexConfigJSON['banner']['mb']} />
      </MobileDisplayContainer>
    </a>
  )
}

export default SexBanner
